import React, { useMemo } from "react";

const SectionHeader = ({ styles, title, desc }) => (
  <div className={styles.sectionHeader}>
    <h2 className={styles.h2}>{title}</h2>
    <div className={styles.divider} />
    {desc ? <p className={styles.sectionDesc}>{desc}</p> : null}
  </div>
);

const InfoCard = ({ styles, title, items, tone = "feature" }) => (
  <div className={`${styles.rowCard} ${tone === "benefit" ? styles.rowCardBenefit : ""}`}>
    <div className={styles.rowCardHeader}>
      <div className={styles.rowCardTitle}>{title}</div>
    </div>

    <ul className={styles.cleanList}>
      {items.map((b, i) => (
        <li key={i} className={styles.cleanListItem}>
          <span className={styles.bulletDot} />
          <span className={styles.bulletText}>{b}</span>
        </li>
      ))}
    </ul>
  </div>
);

const FineTuningResearch = ({ styles }) => {
  const data = useMemo(
    () => ({
      desc:
        "기업의 전용 데이터를 활용하여 LLM의 판단력, 언어 이해도, 도메인 전문성을 고도화하는 맞춤형 학습 모델을 연구합니다. 특정 산업 분야에 최적화된 전용 AI 모델을 구축하는 것이 목표입니다.",
      tech: [
        "Supervised Fine-Tuning(SFT)",
        "Instruction Fine-Tuning",
        "LoRA / QLoRA 기반 경량 파인튜닝",
        "도메인 코퍼스 구축 자동화 파이프라인",
        "Task-specific Evaluation(정확도·추론·요약 능력 평가)",
      ],
      value: ["전문 분야 업무 자동화의 정확도 향상", "LLM 운영비 절감 및 내부 배포 가능(On-Premise)", "기업 전용 AI 기술로 경쟁력 확보"],
      examples: ["국방·의료·금융·교육 도메인 전용 LLM", "보고서 자동화/분류/요약 파이프라인"],
    }),
    []
  );

  return (
    <section className={styles.section} id="research-finetune">
      <div className={styles.container}>
        <SectionHeader styles={styles} title="Custom Fine-Tuning (도메인 특화 LLM 파인튜닝)" desc={data.desc} />

        <div className={styles.panel}>
          <div className={styles.panelTopDots}>
            <span className={styles.panelDot} />
            <span className={styles.panelDot} />
            <span className={styles.panelDot} />
          </div>

          <div className={styles.panelBodyGrid2}>
            <InfoCard styles={styles} title="주요 기술요소" items={data.tech} />
            <InfoCard styles={styles} title="비즈니스 가치" items={data.value} />
          </div>
        </div>

        <div className={styles.subSection}>
          <SectionHeader styles={styles} title="적용 예" desc={null} />
          <div className={styles.targetWrap}>
            {data.examples.map((t, i) => (
              <div className={styles.targetItem} key={i}>
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FineTuningResearch;
